import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('agroinvezt_admin');
    setIsAdmin(stored === 'true');
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const res = await api.post('/api/auth/login', { username, password });
      if (res.success) {
        localStorage.setItem('agroinvezt_admin', 'true');
        setIsAdmin(true);
        return { success: true };
      }
      return { success: false, message: res.message || 'Invalid credentials' };
    } catch (err) {
      const msg = err.message || 'Login failed';
      return {
        success: false,
        message: msg.includes('Failed to fetch') || msg.includes('NetworkError')
          ? 'Unable to connect to server. Please check your connection and try again.'
          : msg,
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('agroinvezt_admin');
    setIsAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ isAdmin, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
